// NOTE: Backend endpoints for field-mappings and setup-complete are pending another
// backend issue; tests use MSW mocks defined in __tests__/msw/handlers.ts.

import { apiGet, apiPatch, apiPost } from '@/lib/http/client';

import type {
  AhoyPropertyType,
  MailchimpFieldMapping,
  MailchimpFieldMappingsResponse,
} from '../types';

export type UpdateMappingBody =
  | Partial<{
      ahoy_property: string | null;
      sync_direction: string;
      conflict_resolution: string | null;
    }>
  | {
      action: 'create_property';
      suggested_name: string;
      field_type: AhoyPropertyType;
    };

export interface CreateMergeFieldBody {
  ahoy_property: string;
  name: string;
  field_type: string;
}

export async function getMailchimpFieldMappings(
  orgId: number | string
): Promise<MailchimpFieldMappingsResponse> {
  return apiGet<MailchimpFieldMappingsResponse>(
    `/api/orgs/${orgId}/mailchimp/field-mappings/`
  );
}

export async function updateMailchimpFieldMapping(
  orgId: number | string,
  mappingId: number,
  body: UpdateMappingBody
): Promise<MailchimpFieldMapping> {
  return apiPatch<MailchimpFieldMapping>(
    `/api/orgs/${orgId}/mailchimp/field-mappings/${mappingId}/`,
    body
  );
}

export async function createMailchimpMergeField(
  orgId: number | string,
  body: CreateMergeFieldBody
): Promise<MailchimpFieldMapping> {
  return apiPost<MailchimpFieldMapping>(
    `/api/orgs/${orgId}/mailchimp/create-merge-field/`,
    body
  );
}

export async function completeMailchimpSetup(
  orgId: number | string,
  backfill: boolean
): Promise<{ success: boolean }> {
  return apiPost<{ success: boolean }>(
    `/api/orgs/${orgId}/mailchimp/setup-complete/`,
    { backfill }
  );
}
